export default "__VITE_ASSET__DHcj5yHs__"